<template>
  <div class="final">
    <p>Take the time to be aware of your surroundings. Spotting potential safety violations helps keep you, customers, and other associates safe in our stores.</p>
    <p>Safety starts with you; help teach and empower associates to work safe each and every day.</p>
    <Button text="Exit" @click.native="exit" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'

export default {
  components: {
    Button
  },
  methods: {
    exit() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.final {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;

  p {
    font-size: 24px;
    margin: 0 auto 25px;
  }

  button {
    margin-top: 10px;
  }
}
</style>